module.exports = __webpack_public_path__ + "static/media/logoSN_ConociendoSantaReliquia_300.4343a9dd.png";